/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
import React, {
  useState, useEffect, forwardRef, useImperativeHandle, useRef,
} from 'react';
import { createPortal } from 'react-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { animated, useSpring } from '@react-spring/web';

import { IoMdClose } from 'react-icons/io';
import styles from './modal.module.scss';

export type IModalHandle = {
  toggle: () => void,
  open: () => void,
  close:() => void,
  isOpen: boolean,
};

const ModalStandalone = forwardRef<IModalHandle, any>(({
  children,
  isDraggable = false,
  domNode = 'modal',
  closeCallBack,
}:{
  children: JSX.Element,
  domNode: string,
  isDraggable: boolean
  closeCallBack?: () => void,
}, ref) => {
  const modalRoot = document.getElementById(domNode);
  const [open, setOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [toggleAnimation, setToggleAnimation] = useState(false);
  // const [prevPos, setPrevPos] = useState([0, 0]);
  useImperativeHandle(ref, () => ({
    toggle: () => {
      setOpen((state) => !state);
      if (open && closeCallBack) {
        closeCallBack();
      }
    },
    open: () => setOpen(true),
    isOpen: open,
    close: () => {
      setOpen(false);
      if (closeCallBack) {
        closeCallBack();
      }
    },
  }));

  function toggle() {
    setOpen((state) => !state);
    if (open && closeCallBack) {
      closeCallBack();
    }
  }

  function close() {
    setToggleAnimation(false);
  }
  const spring = useSpring({
    opacity: toggleAnimation ? 1 : 0,
    onRest: (state: any) => {
      if (state.value.opacity === 0) toggle();
    },
  });

  useEffect(() => {
    if (!ref) console.error('ModalStandalone components need require a ref');
  }, [ref]);

  useEffect(() => {
    if (!modalRoot) {
      console.error(`Can't find the dom element (#${domNode}) where this modal should be mount \nYou should add a div with id : "${domNode}" to public/index.html
     `);
    }
  }, [modalRoot, domNode]);

  useEffect(() => {
    if (open) {
      setToggleAnimation(true);
    }
  }, [open]);

  return (
    <>
      {modalRoot
        && (
        <>
          {createPortal(
            <>
              {(ref && open)
                && (
                <>
                  <animated.div
                    style={{ ...spring }}
                    className={styles['overlay-modal']}
                    onClick={close}
                  />
                    <div
                      className={`${!isDraggable ? styles.modal : ''}`}
                      ref={modalRef}
                    >
                      <animated.div
                        style={{
                          opacity: spring.opacity,
                        }}
                        className={styles.container}
                      >
                        {children}
                        <button onClick={close} className={styles.close}>
                          <IoMdClose />
                        </button>
                      </animated.div>
                    </div>
                </>
                )}
            </>,
            modalRoot,
          )}
        </>
        )}
    </>
  );
});

export default ModalStandalone;
